// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-dialog-title.MuiDialogTitle-root {\n    background-color: #f50057;\n    text-align: center;\n    padding: 50px 25px;\n    color: white;\n}\n\n.error-dialog-title .MuiSvgIcon-root {\n    font-size: 72px;\n}\n\n.error-dialog-content.MuiDialogContent-root {\n    padding: 30px;\n}\n\n.error-dialog-content p {\n    text-align: center;\n    min-width: 460px;\n    font-size: 20px;\n    margin: 25px 0;\n}", ""]);
// Exports
module.exports = exports;
